import React from "react";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { pagesConfigurationSetup } from '../utils/dummydata';
import { useAuthContext } from "./AuthContext";

const PageContentContext = createContext(null);

export const usePageContentContext = () => {
    const context = useContext(PageContentContext);

    if (!context) {
        throw new Error("usePageContentContext must be used within an ContentProvider");
    }
    return context;
};

export const PageContentProvider = ({ children }) => {
    const zones = JSON.parse(localStorage.getItem('nova_videowall_zones'));
    const { tenant } = useAuthContext();
    const pagesConfiguration = pagesConfigurationSetup;
    const [sideBarMenu, setSideBarMenu] = useState(null);
    const [withFilters, setWithFilters] = useState(null);
    const [currentPath, setCurrentPath] = useState(null);
    
    useEffect(() => {
        if (currentPath && tenant && Array.isArray(zones) && zones.length > 0) {
            const actualPageConfig = pagesConfiguration.filter((x) => x.path === currentPath);
            setSideBarMenu(actualPageConfig[0]?.subMenu ?? pagesConfiguration[0]?.subMenu);
            setWithFilters(actualPageConfig[0]?.filters ?? pagesConfiguration[0]?.filters);
        }
    }, [currentPath, tenant]);
    
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const location = window.location.pathname;
            setCurrentPath(location);
        }
    }, [])

    const handlePagePathChange = (pathValue) => {
        if(pathValue){
            setCurrentPath(pathValue);
        }
    }

    const value = useMemo(() => {

        return {
            pagesConfiguration,
            sideBarMenu,
            withFilters,
            currentPath,
            handlePagePathChange
        };
    }, [pagesConfiguration, sideBarMenu, withFilters, currentPath]);

    return <PageContentContext.Provider value={value}>{children}</PageContentContext.Provider>
}